var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { AbortableSubmitEventListener, SubmitEventListener } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { isEnumValid } from '@philips-internal/oswald-ui-utils';
import { BiometryStatus } from './biometry-constants.js';
class BiometryAPI extends ComponentAPI {
    constructor() {
        super(...arguments);
        /** @event */
        this.onBeforeCancel = new AbortableSubmitEventListener();
        /** @event */
        this.onCancel = new SubmitEventListener();
        /** @event */
        this.onBeforeSubmit = new AbortableSubmitEventListener();
        /** @event */
        this.onSubmit = new SubmitEventListener();
    }
    /**
     * Fires the submit event.
     */
    submit() {
        this.onSubmit.fire();
    }
    /**
     * Fires the cancel event.
     */
    cancel() {
        this.onCancel.fire();
    }
    /**
     * Returns the cancel expression.
     */
    getCancelExpression() {
        return this.state.cancelExpression;
    }
    /**
     * Sets the cancel expression.
     *
     * @param cancelExpression - The cancel expression.
     */
    setCancelExpression(cancelExpression) {
        this.setState({ cancelExpression });
    }
    /**
     * Returns the capture expression.
     */
    getCaptureExpression() {
        return this.state.captureExpression;
    }
    /**
     * Sets the capture expression.
     *
     * @param captureExpression - The capture expression.
     */
    setCaptureExpression(captureExpression) {
        this.setState({ captureExpression });
    }
    /**
     * Returns if the biometry is enabled.
     */
    isEnabled() {
        return this.state.enabled;
    }
    /**
     * Sets if the biometry is enabled.
     *
     * @param enabled - If the biometry is enabled.
     */
    setEnabled(enabled) {
        this.setState({ enabled });
    }
    /**
     * Returns the not found expression.
     */
    getNotFoundExpression() {
        return this.state.notFoundExpression;
    }
    /**
     * Sets the not found expression.
     *
     * @param notFoundExpression - The not found expression.
     */
    setNotFoundExpression(notFoundExpression) {
        this.setState({ notFoundExpression });
    }
    /**
     * Returns the remove expression.
     */
    getRemoveExpression() {
        return this.state.removeExpression;
    }
    /**
     * Sets the remove expression.
     *
     * @param removeExpression - The remove expression.
     */
    setRemoveExpression(removeExpression) {
        this.setState({ removeExpression });
    }
    /**
     * Returns the retry expression.
     */
    getRetryExpression() {
        return this.state.retryExpression;
    }
    /**
     * Sets the retry expression.
     *
     * @param retryExpression - The retry expression.
     */
    setRetryExpression(retryExpression) {
        this.setState({ retryExpression });
    }
    /**
     * Returns the biometry status.
     */
    getStatus() {
        return this.state.status;
    }
    /**
     * Sets the biometry status.
     *
     * @param status - The biometry status.
     */
    setStatus(status) {
        if (isEnumValid(BiometryStatus, status)) {
            this.setState({ status });
        }
    }
    /**
     * Returns the touch expression.
     */
    getTouchExpression() {
        return this.state.touchExpression;
    }
    /**
     * Sets the touch expression.
     *
     * @param touchExpression - The touch expression.
     */
    setTouchExpression(touchExpression) {
        this.setState({ touchExpression });
    }
}
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], BiometryAPI.prototype, "onBeforeCancel", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], BiometryAPI.prototype, "onCancel", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], BiometryAPI.prototype, "onBeforeSubmit", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], BiometryAPI.prototype, "onSubmit", void 0);
export { BiometryAPI, };
//# sourceMappingURL=biometry-api.js.map